import { IRootState } from '../../../store'
import { IDispositionState } from '../store/destinationAddress.types'

export const getDestinationAddressSelector = (state: IRootState): IDispositionState => state.disposition
